import _ from 'lodash';
import JSONApiClient from '../jsonapi-service';

export function findInfluencers(organisationId, page, term) {
  const client = JSONApiClient();

  const options = {
    filter: {
      organisation: organisationId,
    },
    include: ['influencer', 'influencerDetails', 'statistics'],
    'page[limit]': 100,
    'page[offset]': (page * 10),
    sort: ['createdDate'],
  };


  return client.find('influencerLink', options)
    .then(r => {
      const influencerArray = [];
      r.forEach(i => {
        const s = i.toJSONTree();
        influencerArray.push(s);
      });
      return influencerArray.reverse();
    });
}

export function countInfluencers(organisationId) {
  const client = JSONApiClient();

  return client.find('influencerLink', { filter: { organisation: organisationId } })
    .then(r => {
      const count = r.length;
      return count;
    });
}

export function getInfluencer(organisationId, id) {
  const client = JSONApiClient();

  return client.get('influencerLink', id, { include: ['influencer', 'influencerDetails', 'influencer.statistics', 'influencerDetails.tags'] })
    .then(r => {
      console.log('ascd', r.toJSONTree());
      return r.toJSONTree();
    });
}

export function runSearch(organisationId, term) {
  const client = JSONApiClient();

  return client.find('influencer', { filter: { name: `:${term}` } });
}

export function addInfluencer(data) {
  const client = JSONApiClient();
  const influencer = client.create('influencer');

  influencer.set('name', data.name);
  influencer.set('primarySocialHandle', data.primarySocialHandle);
  influencer.set('facebookCount', (data.facebookCount || 0));
  influencer.set('instagramCount', (data.instagramCount || 0));
  influencer.set('twitterCount', (data.twitterCount || 0));
  influencer.set('youtubeCount', (data.youtubeCount || 0));
  influencer.set('otherChannels', data.otherChannels);
  influencer.set('totalSocialReach', data.totalSocialReach);

  const fields = [
    'email',
    'contactNumber',
    'thumbnail',
    'facebook',
    'instagram',
    'twitter',
    'youtube',
    'agentName',
    'agentContactNumber',
    'addressLine1',
    'city',
    'region',
    'postalCode',
    'country',
    'youtubeChannelTitle',
    'twitch',
    'snapchat',
    'linkedin',
    'web',
  ];

  _.forEach(fields, field => {
    const value = data[field];
    if (value) {
      influencer.set(field, value);
    }
  });

  return influencer.sync()
    .then(r => {
      const flat = r.toJSON();
      return flat.id;
    });
}

export function addInfluencerDetails(details) {
  const client = JSONApiClient();
  const influencerDetails = client.create('influencerDetails');

  influencerDetails.set('associated', details.associated);
  influencerDetails.set('contentTags', details.contentTags);
  influencerDetails.set('brandTags', details.brandTags);
  influencerDetails.set('description', details.description);

  if (details.email) {
    influencerDetails.set('email', details.email);
  }

  return influencerDetails.sync()
    .then(r => {
      const flat = r.toJSON();
      return flat.id;
    });
}

export function addInfluencerLink(organisationId, influencerId, influencerDetailsId) {
  const client = JSONApiClient();
  const influencerLink = client.create('influencerLink');

  influencerLink.set('organisation', { type: 'organisations', id: organisationId });
  influencerLink.set('influencer', { type: 'influencer', id: influencerId });
  influencerLink.set('influencerDetails', { type: 'influencerDetails', id: influencerDetailsId });

  return influencerLink.sync()
    .then(r => console.log(r.toJSON().id));
}

export function getOrganisationName(organisationId) {
  const client = JSONApiClient();

  return client.get('organisations', organisationId)
    .then(r => r.toJSONTree());
}

export function getReviews(influencer) {
  const client = JSONApiClient();

  return client.get('influencer', influencer).then(r => r.toJSONTree().reviews);
}

export function setRating(influencerDetailsId, avg) {
  const client = JSONApiClient();

  return client.get('influencerDetails', influencerDetailsId)
    .then(i => {
      i.set('assessment', avg);
      return i.sync();
    });
}

export function setReviews(influencer, final) {
  const client = JSONApiClient();

  return client.get('influencer', influencer)
    .then(i => {
      i.set('reviews', final);
      return i.sync();
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/influencers.js
 **/